// extracted by mini-css-extract-plugin
export default {"cls1":"CitationModal-cls1_mw5","cls2":"CitationModal-cls2_OR1 CitationModal-cls1_mw5"};